import React, { Component } from 'react'
import FontIcon from '../../../Components/Atom/FontIcon'
import style from './style.css'

export default class Tag extends Component {
    render () {
        return (
            <div className={style.cardCheckWrap}>
                <input
                    type="checkbox"
                    checked={this.props.isChecked}
                    onChange={e => this.props.handleChange(e)}
                    className={style.cardCheckbox} id={this.props.id} name={this.props.id}/>
                <label htmlFor={this.props.id}>
                    {this.props.icon && 
                        <FontIcon name={this.props.icon || ''} color="white" size={10} />
                    }
                    {this.props.name}
                </label>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/App/Components/Atom/Tag/index.js